import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import Icons from '../../../../../common/widgets/Icons';
import PopoverDialog from '../../../../../common/widgets/PopoverDialog';
import { UserAvatar } from '../../../components/UserAvatar';
import { AccountInfoContext } from '../../../contexts/AccountInfoContext';
import { resources } from '../../../resources/resources';

export default function Account() {
  const { accountInfo } = useContext(AccountInfoContext);

  return (
    <>
      <PopoverDialog
        className="dropdown-menu-list m-header-dropdown m-user-dropdown"
        placement="bottom"
        closeFromContent
        type="hover"
        content={<UserMenu />}
      >
        <a className="btn app-bar-tools-btn app-bar-user">
          <UserAvatar
            color1={accountInfo.avatarColor1}
            color2={accountInfo.avatarColor2}
            fontColor={accountInfo.avatarFontColor}
            initials={accountInfo.initials}
          />
          <span>{accountInfo.fullName}</span>
          <span className="btn-icon">
            <Icons.ArrowDown />
          </span>
        </a>
      </PopoverDialog>
    </>
  );
}

const UserMenu = () => {
  const { t: translate } = useTranslation();

  const navigate = useNavigate();
  const auth = useAuth();
  const handleLogout = async () => {
    try {
      await auth.signoutRedirect();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <ul>
      <li onClick={() => navigate('/accounts/my-account/details')}>
        <a>{translate(resources.userMenu.account)}</a>
      </li>
      <li onClick={() => navigate('/accounts/my-account/change-password')}>
        <a>{translate(resources.userMenu.changePassword)}</a>
      </li>
      <li onClick={() => navigate('/accounts/my-account/authentication')}>
        <a>{translate(resources.userMenu.communication)}</a>
      </li>
      <li>
        <button
          type="button"
          onClick={handleLogout}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
          }}
        >
          {translate(resources.userMenu.logout)}
        </button>
      </li>
    </ul>
  );
};
